import React, { useState, useEffect, useMemo } from "react";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "moment-jalaali";
import SVG from "react-inlinesvg";
import { InputGroup, FormControl, FormLabel, FormText } from 'react-bootstrap';
import { useLang } from "../../../i18n/Basei18n";
import { useField, useFormikContext } from "formik";
import {
  formatDateString,
  convertDateStringToLocal,
  initDatePickerValue,
} from "../../../_helpers/DateFormaterHelpers";
import { toAbsoluteUrl } from "../../../_helpers";
// import { utils } from 'react-modern-calendar-datepicker';
// import "./customDatePickerWidth.css";
// import { DateTimeInput, DateTimeInputSimple, DateInput, DateInputSimple } from 'react-hichestan-datetimepicker';
// import DatePicker from "react-datepicker";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control "];
  if (touched && errors) {
    classes.push("is-invalid");
  }
  if (touched && !errors) {
    classes.push("is-valid");
  }
  return classes.join(" ");
};


export function DatePickerField({ returnTime = "00:00:00", ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const { field } = props;
  const locale = useLang();
  const [selectedDay, setSelectedDay] = useState(null);

  const [onSelected, setOnSelected] = useState(0);
  const [counter, setCounter] = useState(999);
  const tdOnClick = (index) => {
    setCounter(counter + index + 1)
    setOnSelected(index);
  };

  // const [meta, helpers] = useField(props.name);

  // const { value } = meta;
  // const { setValue } = helpers;

  // useEffect(() => {
  //   if (field.value) {
  //     var date = convertDateStringToLocal(field.value, locale)
  //     var d = new Date(date),
  //       month = "" + (d.getMonth() + 1),
  //       day = "" + d.getDate(),
  //       year = d.getFullYear();
  //     setSelectedDay({
  //       day: day,
  //       month: month,
  //       year: year,
  //     });
  //   }

  // }, [field.value]);

  const setDatepickerValue = ({
    val,
    field,
    locale,
    setFieldValue,
  }) => {

    // console.log(meta.value)
    let utcDate = null;
    if (locale === "fa") {
      utcDate = moment(`${val.year}/${val.month}/${val.day} ${returnTime}`, "jYYYY/jM/jD HH:mm:ss");
    } else {
      utcDate = moment(`${val.year}-${val.month}-${val.day} ${returnTime}`, "YYYY-MM-DD HH:mm:ss");
    }
    let newValue = utcDate.format("YYYY-MM-DDTHH:mm:ss");
    setFieldValue(field.name, newValue);
    setSelectedDay(val);
    if (props.onChange) {
      props.onChange()
    }
  };


  const renderCustomInput = ({ ref }) => (
    <input
      ref={ref} // necessary
      value={field.value ? convertDateStringToLocal(field.value, locale) : null}
      readOnly={true}
      style={{
        // width: "100%",
        // fontSize: "1.5rem"
        // display: "block"
      }}
      className={getFieldCSSClasses(touched[field.name], errors[field.name])}
    // wrapperClassName="datepicker"

    // className='date-input-field'
    />
  )

  // const renderCustomInputFilter = ({ ref }) => (
  //   <input
  //     ref={ref} // necessary
  //     // placeholder="I'm a custom input"
  //     value={selectedDay}
  //     style={{
  //       width: "100%"
  //     }}
  //     className={getFieldCSSClasses(touched[field.name], errors[field.name])}
  //   />
  // )

  const minimumDateEn = {
    year: 2021,
    month: 3,
    day: 21
  };

  const minimumDateFa = {
    year: 1400,
    month: 1,
    day: 1
  };

  return (
    <>
      {props.label && <label>{props.label}</label>}
      <div
        style={{ position: "relative", zIndex: props.rowIdx === onSelected && counter + 1 }}
        onClick={() => {
          tdOnClick(props.rowIdx)
        }}
      >
        <DatePicker
          {...field}
          {...props}
          locale={locale}
          isRtl={locale == "en" ? false : true}
          minimumDate={locale == "en" ? minimumDateEn : minimumDateFa}
          // colorPrimary="#be9a57"
          // calendarPopperPosition="bottom"
          // formatInputText="YYYY/MM/DD"
          value={selectedDay}
          // onChange={setSelectedDay}
          onChange={(val) => {
            setDatepickerValue({
              val,
              field,
              locale,
              setFieldValue,
            });
          }}
          shouldHighlightWeekends
          renderInput={renderCustomInput} // render a custom input
          calendarClassName="responsive-calendar"
        // renderInput={props.label ? renderCustomInput : renderCustomInputFilter} // render a custom input

        // renderFooter={() => (
        //   <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 2rem' }}>
        //     <button
        //       type="button"
        //       onClick={() => {
        //         setSelectedDay(null);
        //         setFieldValue(field.name, "");
        //         if (props.onChange) {
        //           props.onChange()
        //         }
        //       }}
        //       style={{
        //         border: '#0fbcf9',
        //         color: '#be9a57',
        //         borderRadius: '0.5rem',
        //         padding: '1rem 2rem',
        //       }}
        //     >
        //       پاک کردن
        //     </button>
        //   </div>
        // )}
        />
        {/* </InputGroup> */}
      </div>
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        <div className="feedback">
          {/* Please enter <b>{props.label}</b> in 'mm/dd/yyyy' format */}
        </div>
      )}

    </>
  );
}
